import { ButtonMenu } from "../ButtonMenu";
import { Icon } from "../Icon";
import { useMsg } from "../Msg/Msg";
import { generalMessages } from "../messages";
import { downloadCsvProps } from "./downloadCsvProps";

export const DownloadData = ({
  query,
  data = query?.data,
  disabled = query?.isFetching,
  fileName,
}) => {
  const msg = useMsg({ dict: generalMessages });
  // const { guessedCsvDelimiter } = useContext(I18nContext);

  return (
    <ButtonMenu
      button={{
        variant: "outlined",
        "aria-label": "download CSV",
        startIcon: <Icon name="Download" />,
        children: msg("general.export.csv"),
      }}
      items={[
        {
          key: 1,
          children: msg("general.delimiter", { delimiter: '","' }),
          ...downloadCsvProps({
            data,
            disabled,
            delimiter: ",",
            fileName,
          }),
        },
        {
          key: 2,
          children: msg("general.delimiter", { delimiter: '";"' }),
          ...downloadCsvProps({
            data,
            disabled,
            delimiter: ";",
            fileName,
          }),
        },
      ]}
    />
  );
};
